import { StyleSheet } from 'react-native';
import { neutrals, shadows } from 'src/theme/colors';

export const styles = StyleSheet.create({
  previewBackgroundContainer: {
    pointerEvents: 'none',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  previewShadow: {
    width: '100%',
    height: '100%',
    shadowColor: shadows.shadowOne,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.15,
    shadowRadius: 12,

    elevation: 4,
  },
  previewWhite: {
    backgroundColor: neutrals.white,
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  },
});
